import { render, staticRenderFns } from "./TextInformativeModalPublic.vue?vue&type=template&id=6dcca39a&scoped=true&"
import script from "./TextInformativeModalPublic.vue?vue&type=script&lang=js&"
export * from "./TextInformativeModalPublic.vue?vue&type=script&lang=js&"
import style0 from "./TextInformativeModalPublic.vue?vue&type=style&index=0&id=6dcca39a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcca39a",
  null
  
)

export default component.exports